import React from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

export const BackgroundBeams = ({ className }) => {
    const paths = [
        "M-100 0 L-100 1000",
        "M100 0 L100 1000",
        "M300 0 L300 1000",
        "M500 0 L500 1000",
        "M700 0 L700 1000",
        "M900 0 L900 1000",
        "M1100 0 L1100 1000",
        "M1300 0 L1300 1000",
    ];

    return (
        <div
            className={cn(
                "absolute inset-0 z-0 flex h-full w-full items-center justify-center overflow-hidden bg-white opacity-20",
                className
            )}
        >
            <svg
                className="h-full w-full pointer-events-none absolute inset-0"
                width="100%"
                height="100%"
                viewBox="0 0 1440 1000"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {paths.map((path, index) => (
                    <motion.path
                        key={index}
                        d={path}
                        stroke="url(#paint0_linear)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        initial={{
                            strokeDasharray: "10 10",
                            strokeDashoffset: 0,
                            opacity: 0.2,
                        }}
                        animate={{
                            strokeDashoffset: [0, 1000],
                            opacity: [0.2, 0.5, 0.2],
                        }}
                        transition={{
                            duration: Math.random() * 10 + 10,
                            repeat: Infinity,
                            ease: "linear",
                            delay: Math.random() * 5,
                        }}
                    />
                ))}
                <defs>
                    <linearGradient
                        id="paint0_linear"
                        x1="720"
                        y1="0"
                        x2="720"
                        y2="1000"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#A855F7" />
                        <stop offset="1" stopColor="#6366F1" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    );
};
